//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NavBar from '@/components/NavBar';
import CommonFooter from '@/components/CommonFooter';
import TitleBox from '@/components/TitleBox';
import ScrollTop from '@/components/ScrollTop.vue';

export default {
    components: { NavBar, CommonFooter, TitleBox, ScrollTop },
    beforeRouteEnter(to, from, next) {
        const obj = {
            activities: 0,
            news: 1
        };
        const params = to.params;
        if (params.anchor && !params.id) {
            next(vm => {
                vm.currentItem = obj[params.anchor];
            });
            return;
        }
        /* if (params.anchor && params.id) {
            var propName = '';
            if (params.anchor === 'guide') {
                propName = 'defGuide';
            }
            if (params.anchor === 'video') {
                propName = 'defVideo';
            }
            next(vm => {
                vm[propName] = params.id;
                vm.currentItem = obj[params.anchor];
            });
            return;
        } */
        next(vm => {
            vm.currentItem = 0;
        });
    },
    beforeRouteUpdate(to, from) {
        const obj = {
            activities: 0,
            news: 1
        };
        this.currentItem = obj[to.query.anchor];
    },
    data() {
        return {
            typeList: [],
            currentItem: 0,
            actList: [],
            actDetail: '',
            newsList: [],
            recommendList: [],
            newDetail: '',
            show: {
                newDetail: false,
                actDetail: false
            },
            banner: ''
        };
    },
    watch: {
        currentItem() {
            this.show.actDetail = false;
            this.show.newDetail = false;
            if (this.currentItem === 0 && !this.actId) {
                this.getActList();
            }
            if (this.currentItem === 0 && this.actId) {
                this.getActDetail(this.actId);
                this.actId = null;
            }
            if (this.currentItem === 1 && !this.newId) {
                this.getNewsList(1).then(() => {
                    this.initNews();
                });
                this.getNewsList();
            }
            if (this.currentItem === 1 && this.newId) {
                this.getNewDetail(this.newId);
                this.newId = null;
            }
        },
        i18n() {
            this.show.actDetail = false;
            this.show.newDetail = false;
            if (this.currentItem === 0) {
                this.getActList();
            }
            if (this.currentItem === 1) {
                this.getNewsList(1).then(() => {
                    this.initNews();
                });
                this.getNewsList();
            }
        }
    },
    mounted() {
        this.getTypes();
        this.getActList().then(() => {
            // this.initAct();
        });
        this.getNewsList();
    },
    methods: {
        initNews() {
            new window.Swiper('#news', {
                // 循环模式选项
                loop: false,
                /* autoplay: {
                    disableOnInteraction: false
                }, */
                effect: 'fade',
                pagination: {
                    el: '#news .swiper-pagination'
                },
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '#news .swiper-button-next',
                    prevEl: '#news .swiper-button-prev'
                }
            });
        },
        getTypes() {
            this.axios({
                method: 'post',
                url: '/articleCategory/list',
                data: {
                    pid: 2
                }
            }).then(res => {
                if (res.code === 0) {
                    this.typeList = res.data;
                }
            });
        },
        getActList() {
            return this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '54',
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then(res => {
                if (res.code === 0) {
                    this.actList = res.data.data;
                }
            });
        },
        getActDetail(id) {
            this.axios({
                method: 'post',
                url: '/article/detail',
                data: {
                    id
                }
            }).then(res => {
                if (res.code === 0) {
                    this.actDetail = res.data;
                    this.show.actDetail = true;
                }
            });
        },
        getNewsList(recommend = 0) {
            return this.axios({
                method: 'post',
                url: '/article/listPage',
                data: {
                    categoryId: '55',
                    recommend: recommend,
                    pageNum: 1,
                    pageSize: 100,
                    language: this.i18n
                }
            }).then(res => {
                if (res.code === 0) {
                    if (recommend) {
                        this.recommendList = res.data.data;
                    } else {
                        this.newsList = res.data.data;
                    }
                }
            });
        },
        getNewDetail(id) {
            this.scrollTop('auto');
            this.axios({
                method: 'post',
                url: '/article/detail',
                data: {
                    id
                }
            }).then(res => {
                if (res.code === 0) {
                    this.newDetail = res.data;
                    this.show.newDetail = true;
                }
            });
        },
        newsDetailBack() {
            this.show.newDetail = false;
            this.$nextTick(() => {
                this.initNews();
            });
        }
    }
};
